import { z } from "zod";

import { type ChatMessage, getActionIdentifier, isBatchApplicableActionMessage } from "../../../types/chat";

const storedCardNumberSchema = z.object({ card_number: z.number().int().positive() });

function storedCardNumberOf(toolContent: string): number | null {
  try {
    const parsed = storedCardNumberSchema.safeParse(JSON.parse(toolContent));
    return parsed.success ? parsed.data.card_number : null;
  } catch {
    return null;
  }
}

export class ChatCardNumbers {
  private numberByCardId: ReadonlyMap<string, number> = new Map();

  publish(numberByCardId: ReadonlyMap<string, number>): void {
    this.numberByCardId = numberByCardId;
  }

  numberOf(cardId: string | null): number | null {
    if (cardId === null) return null;
    return this.numberByCardId.get(cardId) ?? null;
  }
}

export const chatCardNumbers = new ChatCardNumbers();

export function cardNumbersOf(messages: ChatMessage[]): Map<string, number> {
  const numbers = new Map<string, number>();
  let highestCardNumber = 0;
  messages.forEach((message, index) => {
    if (!isBatchApplicableActionMessage(message)) return;
    const cardNumber = storedCardNumberOf(message.content) ?? highestCardNumber + 1;
    highestCardNumber = Math.max(highestCardNumber, cardNumber);
    numbers.set(getActionIdentifier(message, `msg-${index}`), cardNumber);
  });
  return numbers;
}
